import { useState } from "react";
import { useSettings } from "@/context/SettingsContext";
import { MessageCircle, X } from "lucide-react";

export default function FloatingWhatsApp({ source = "homepage" }) {
  const { openWhatsapp } = useSettings();
  const [expanded, setExpanded] = useState(true);

  return (
    <div className="fixed bottom-5 right-5 z-40 flex items-center gap-2" data-testid="floating-whatsapp">
      {expanded && (
        <button
          onClick={() => openWhatsapp(source)}
          className="hidden sm:flex items-center gap-2 rounded-full bg-chessup-card border border-chessup-border px-4 py-3 text-sm text-chessup-text shadow-xl hover:border-chessup-turq transition-colors animate-fade-in"
          aria-label="Falar com a ChessUp no WhatsApp"
          data-testid="whatsapp-expanded-label"
        >
          Falar com a ChessUp
        </button>
      )}
      <button
        onClick={() => openWhatsapp(source)}
        className="h-14 w-14 rounded-full flex items-center justify-center shadow-[0_8px_30px_rgba(37,211,102,0.45)] hover:scale-105 transition-transform"
        style={{ background: "#25D366" }}
        aria-label="Abrir WhatsApp da ChessUp Academy"
        data-testid="whatsapp-fab"
      >
        <MessageCircle className="h-7 w-7 text-white" fill="currentColor" />
      </button>
      <button
        onClick={() => setExpanded((e) => !e)}
        className="absolute -top-2 -left-2 h-5 w-5 rounded-full bg-chessup-deep border border-chessup-border text-chessup-subtext hidden sm:flex items-center justify-center"
        aria-label="Ocultar rótulo"
      >
        <X className="h-3 w-3" />
      </button>
    </div>
  );
}
